<app-modal class="ticket-on-hold-modal">
    <div class="modal-header" modal-header>
        <h4 class="modal-title">{{ 'ticket-on-hold-modal.title' | translate }}</h4>
    </div>
    <div class="modal-body" modal-body>
        <form [formGroup]="onHoldForm">
            <p class="modal-subtitle">{{ 'ticket-on-hold-modal.subtitle' | translate }}</p>
            <app-dropdown-autocomplete [formControl]="onHoldForm.controls['reason']"
                                       formControlName="reason"
                                       [items]="reasons"
                                       valueField="id"
                                       displayField="name"
                                       appendTo="body"
                                       [useObjects]="false"
                                       [showErrors]="showValidations"
                                       [label]="'ticket-on-hold-modal.reason.label' | translate"
                                       [emptyText]="'ticket-on-hold-modal.reason.placeholder' | translate">
            </app-dropdown-autocomplete>
            <app-textarea [formControl]="onHoldForm.controls['description']"
                          formControlName="description"
                          [required]="true"
                          [maxLength]="300"
                          [showErrors]="showValidations"
                          [label]="'ticket-on-hold-modal.description.label' | translate"
                          [placeholder]="'ticket-on-hold-modal.description.placeholder' | translate">
            </app-textarea>
        </form>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    data-dismiss="modal">
            {{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button type="primary"
                    (click)="onConfirm()"
                    data-dismiss="modal">
            {{ "generic.buttons.confirm" | translate }}
        </app-button>
    </div>
</app-modal>
